import { memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

export type DesignPreviewCardProps = {
  /** Resolved hex for the page background. The composition resolves custom-vs-default — no defaulting here. */
  backgroundColor: string;
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
};

/**
 * The bordered/rounded container that frames a share-page Design preview. Holds no preview-specific
 * layout itself — the composition decides height (auto vs fixed) via `className`.
 */
export const DesignPreviewCard = memo(
  ({ backgroundColor, children, className, 'data-testid': dataTestId }: DesignPreviewCardProps) => (
    <div
      className={cn(
        'relative flex w-full shrink-0 flex-col overflow-hidden rounded-8 border ads:border-ads-gray-5 border-gray-5',
        className,
      )}
      data-testid={dataTestId}
      style={{ backgroundColor }}
    >
      {children}
    </div>
  ),
);

DesignPreviewCard.displayName = 'DesignPreviewCard';
